import React, { useState } from "react";
import { API_BASE_URL } from "../config";
import { useNavigate } from "react-router-dom";
import "./SignUp.css"; // Import the CSS file
import { FaArrowLeft } from "react-icons/fa";

const ForgotPassword = () => {
  const [mode, setMode] = useState("email"); // "email" or "phone"
  const [email, setEmail] = useState("");
  const [phone, setPhone] = useState("");
  const [errors, setErrors] = useState({});
  const [loading, setLoading] = useState(false);
  const [successMessage, setSuccessMessage] = useState("");
  const navigate = useNavigate();

  const handleForgotPassword = async () => {
    const newErrors = {};

    if (mode === "email") {
      if (!email) newErrors.email = "Email is required.";
    } else {
      if (!phone) newErrors.phone = "Phone number is required.";
    }

    if (Object.keys(newErrors).length > 0) {
      setErrors(newErrors);
      return;
    }

    setLoading(true);
    setErrors({});
    setSuccessMessage("");

    try {
      let response, data;
      if (mode === "email") {
        // Example API for email
        const formData = new FormData();
        formData.append("email", email);        response = await fetch(
          `${API_BASE_URL}/forgot-password`,
          {
            method: "POST",
            body: formData,
          }
        );
        data = await response.json();
      } else {
        // Example API for phone (replace with actual API later)
        const formData = new FormData();
        formData.append("phone", phone);        response = await fetch(
          `${API_BASE_URL}/forgot-password-with-phone`,
          {
            method: "POST",
            body: formData,
          }
        );
        data = await response.json();
      }

      if (response.ok) {
        if (data.statusCode === 1) {
          if (mode === "email") {
            setSuccessMessage(
              "Password reset instructions have been sent to your email."
            );
          } else {
            // Redirect to ResetPasswordWithPhone with phone number
            navigate("/reset-password-phone", { state: { phone } });
            return;
          }
        } else {
          setErrors({
            api: data.statusMessage || "An error occurred. Please try again.",
          });
        }
      } else {
        setErrors({
          api:
            mode === "email"
              ? "Failed to send password reset instructions. Please try again."
              : "Failed to send password reset instructions to phone. Please try again.",
        });
      }
    } catch (error) {
      setErrors({
        api: "An unexpected error occurred. Please try again later.",
      });
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="container d-flex justify-content-center align-items-center vh-100">
      <div
        className="card p-4 signup-card"
        style={{ maxWidth: "500px", width: "100%" }}
      >
        {successMessage ? (
          <div className="text-center py-4">
            <div className="mb-3">
              <svg
                width="60"
                height="60"
                viewBox="0 0 24 24"
                fill="none"
                xmlns="http://www.w3.org/2000/svg"
              >
                <circle cx="12" cy="12" r="12" fill="#e6f9ed" />
                <path
                  d="M7 13.5L11 17L17 9.5"
                  stroke="#28a745"
                  strokeWidth="2.5"
                  strokeLinecap="round"
                  strokeLinejoin="round"
                />
              </svg>
            </div>
            <h4 className="text-success mb-2">Success!</h4>
            <p className="mb-2">{successMessage}</p>
            <p className="text-muted" style={{ fontSize: "15px" }}>
              Please check your email inbox for further instructions to reset
              your password.
            </p>
          </div>
        ) : (
          <>
            <div className="d-flex align-items-center justify-content-between mb-4">
              <button
                className="btn btn-link text-decoration-none d-flex align-items-center"
                onClick={() => navigate("/")}
              >
                <FaArrowLeft className="me-2" />
                Home
              </button>
              <h2 style={{ width: "70%" }} className="text-left mb-1">
                Forgot Password
              </h2>
            </div>
            <div className="d-flex justify-content-center mb-3">
              <button
                className={`btn border w-25 ${
                  mode === "email" ? "fw-bold" : "text-muted custom-bg"
                }`}
                onClick={() => setMode("email")}
              >
                Email
              </button>
              <button
                className={`btn border w-25 ms-2 ${
                  mode === "phone" ? "fw-bold" : "text-muted custom-bg"
                }`}
                onClick={() => setMode("phone")}
              >
                Phone
              </button>
            </div>

            {mode === "email" ? (
              <>
                <div className="mb-3">
                  <label className="form-label">Email</label>
                  <input
                    type="email"
                    className="form-control"
                    placeholder="Enter your email"
                    maxLength={64}
                    value={email}
                    onChange={(e) => setEmail(e.target.value)}
                  />
                  {errors.email && (
                    <div className="text-danger mt-1">{errors.email}</div>
                  )}
                </div>
              </>
            ) : (
              <>
                <div className="mb-3">
                  <label className="form-label">Phone Number</label>
                  <input
                    type="text"
                    className="form-control"
                    placeholder="Enter your phone number"
                    maxLength={14}
                    value={phone}
                    onChange={(e) => setPhone(e.target.value)}
                  />
                  {errors.phone && (
                    <div className="text-danger mt-1">{errors.phone}</div>
                  )}
                </div>
              </>
            )}

            {errors.api && <div className="text-danger mb-2">{errors.api}</div>}

            <button
              className="btn btn-primary w-100"
              onClick={handleForgotPassword}
              disabled={loading}
            >
              {loading
                ? "Sending..."
                : mode === "email"
                ? "Send Reset Instructions"
                : "Send OTP"}
            </button>

            <div className="text-center mt-3">
              Remembered your password?{" "}
              <span
                className="text-primary text-decoration-underline"
                style={{ cursor: "pointer" }}
                onClick={() => navigate("/login/forgot-password")}
              >
                Login
              </span>
            </div>
          </>
        )}
      </div>
    </div>
  );
};

export default ForgotPassword;
